// @flow
import { call, fork, put, take } from 'redux-saga/effects'
import { GET_USER, setUser } from 'src/redux/actions/user/user'
import http from 'src/services/http'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetUser(): Generator<IOEffect, void, any> {
  while (true) {
    yield take(GET_USER.REQUEST)
    try {
      const { data } = yield call(http, 'api/account', {
        method: 'GET',
      })
      yield put(setUser.success(data))
    } catch (e) {
      yield put(setUser.error(e.message))
    }
  }
}

export default [fork(watchGetUser)]
